var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66659 8.00001H3.92123C4.37803 8.00001 4.79563 8.25809 4.99992 8.66667C5.20421 9.07525 5.6218 9.33334 6.07861 9.33334H9.92123C10.378 9.33334 10.7956 9.07525 10.9999 8.66667C11.2042 8.25809 11.6218 8.00001 12.0786 8.00001H14.3333M5.97763 2.66667H10.0222C10.7401 2.66667 11.0991 2.66667 11.416 2.77598C11.6962 2.87265 11.9515 3.0304 12.1633 3.23784C12.4028 3.4724 12.5633 3.79347 12.8844 4.43559L14.3288 7.32434C14.4547 7.57633 14.5177 7.70232 14.5622 7.83437C14.6016 7.95164 14.6301 8.07232 14.6473 8.19485C14.6666 8.33282 14.6666 8.47369 14.6666 8.75542V10.1333C14.6666 11.2534 14.6666 11.8135 14.4486 12.2413C14.2569 12.6176 13.9509 12.9236 13.5746 13.1154C13.1467 13.3333 12.5867 13.3333 11.4666 13.3333H4.53325C3.41315 13.3333 2.85309 13.3333 2.42527 13.1154C2.04895 12.9236 1.74299 12.6176 1.55124 12.2413C1.33325 11.8135 1.33325 11.2534 1.33325 10.1333V8.75542C1.33325 8.47369 1.33325 8.33282 1.35257 8.19485C1.36972 8.07232 1.39821 7.95164 1.43767 7.83437C1.48209 7.70233 1.54509 7.57633 1.67108 7.32434L3.11546 4.43559C3.43652 3.79347 3.59705 3.4724 3.83655 3.23784C4.04834 3.0304 4.30359 2.87265 4.58384 2.77598C4.90075 2.66667 5.25971 2.66667 5.97763 2.66667Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesInbox);
export default __webpack_public_path__ + "static/media/sales-inbox.df906e2082cd07cd2c805b05ba2e2d21.svg";
export { ForwardRef as ReactComponent };